import { createFileRoute } from '@tanstack/react-router';

import { EarlyAccessPage } from '../components/marketing/EarlyAccessPage';

/**
 * /earlyaccess — the pre-launch early-access capture (was /waitlist, which
 * now 301s here). `?as=artist|venue` preselects the segment; the two CTAs use
 * the preset paths /earlyaccessartist and /earlyaccessvenue instead.
 */

type EarlyAccessSearch = { as?: 'artist' | 'venue' };

export const Route = createFileRoute('/earlyaccess')({
  validateSearch: (s: Record<string, unknown>): EarlyAccessSearch => {
    const out: EarlyAccessSearch = {};
    // Accept the venue synonyms so a `?as=host` link still lands on the venue
    // toggle; anything else falls through to the form's default (artist).
    if (s.as === 'venue' || s.as === 'host') out.as = 'venue';
    else if (s.as === 'artist') out.as = 'artist';
    return out;
  },
  component: EarlyAccessRoute,
});

function EarlyAccessRoute() {
  const initialLeadType = Route.useSearch({ select: (s) => s.as ?? 'artist' });
  return <EarlyAccessPage initialLeadType={initialLeadType} />;
}
